module.exports = __webpack_public_path__ + "img/copy.025a13d4.svg";